import { fetchTimeline } from '@lotushealth/lotushealth_js_sdk/endpoints';
import { lotusHealthZod } from '@lotushealth/lotushealth_js_sdk';
import type {
  FetchTimelineParams,
  FetchTimelineResponseT,
} from '@lotushealth/lotushealth_js_sdk/schemas';

import { createLotusRequestConfig } from '@/shared/api/lotus';

export async function fetchCareTimeline(
  userId: string,
  params?: FetchTimelineParams,
  signal?: AbortSignal
): Promise<FetchTimelineResponseT> {
  const config = await createLotusRequestConfig({ signal });
  const response = await fetchTimeline(userId, params, config);
  return lotusHealthZod.fetchTimelineResponse.parse(response.data) as FetchTimelineResponseT;
}
